module.exports = __webpack_public_path__ + "static/media/portrait-3.bf8df984.jpg";